import { render, staticRenderFns } from "./faceUpload.vue?vue&type=template&id=46a30764&scoped=true&"
import script from "./faceUpload.vue?vue&type=script&lang=js&"
export * from "./faceUpload.vue?vue&type=script&lang=js&"
import style0 from "./faceUpload.vue?vue&type=style&index=0&id=46a30764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a30764",
  null
  
)

export default component.exports